import Sheet from 'components/utils/Sheet'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import type { ComponentProps } from 'react'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'

function LoyaltyChooseDoubleRewardsBackground({ className, placement }: ComponentProps<App.SiteTakeoverConfig['backgroundElement']>) {
  const loggedIn = useAppSelector(selectLoggedIn)
  const hasAccount = useAppSelector(getHasLoyaltyAccount)

  const background = placement === 'siteWideBanner' && (!loggedIn || !hasAccount) ? 'none' : 'light-background'

  return <Sheet className={className} background={background} />
}

export default LoyaltyChooseDoubleRewardsBackground
